import 'phaser'
import { l } from '../lib/imports'
import { scene } from '../main/scene-sidecar'
import { machines } from '../machines/machines-sidecar'
import { IMachineType } from '../machines/machinesData'

export interface IMachineSaved {
  type: IMachineType
  i: number
  j: number

  emergencySupply: number
  waterSupply: number
  batterySupply: number
  hydrogenSupply: number
  progress: number
  hasSuit: boolean
  isOccupied: boolean
}

export function save() {
  let sd: IMachineSaved[] = []

  let objs = machines.getAll()
  l.forEach(objs, (c) => {
    sd.push({
      i: c.i,
      j: c.j,
      type: c.data.type,
      emergencySupply: c.emergencySupply,
      waterSupply: c.waterSupply,
      batterySupply: c.batterySupply,
      hydrogenSupply: c.hydrogenSupply,
      progress: c.progress,
      hasSuit: c.hasSuit,
      isOccupied: c.isOccupied,
    })
  })

  return sd
}

export function load(sd: IMachineSaved[]) {
  let ctx = scene.getContext()
  l.forEach(sd, (c) => {
    let obj = machines.create(c.type)
    obj.emergencySupply = c.emergencySupply
    obj.waterSupply = c.waterSupply
    obj.batterySupply = c.batterySupply
    obj.hydrogenSupply = c.hydrogenSupply
    obj.progress = c.progress
    obj.hasSuit = c.hasSuit
    obj.isOccupied = c.isOccupied
    machines.moveToTile(obj, ctx.mapShip, c.i, c.j)
  })
}
